<script setup lang="ts">
import HeroLegalContent from '~/components/pages/legal-content/Hero.vue'
import IconShield from '~/components/icons/legal-content/IconShield.vue'
import IntroductionSection from '~/components/pages/privacy-policy/IntroductionSection.vue'
import ControllerSection from '~/components/pages/privacy-policy/ControllerSection.vue'
import InformationSection from '~/components/pages/privacy-policy/InformationSection.vue'
import PersonalDataSection from '~/components/pages/privacy-policy/PersonalDataSection.vue'
import DataTransfersSection from '~/components/pages/privacy-policy/DataTransfersSection.vue'
import TechnicalSection from '~/components/pages/privacy-policy/TechnicalSection.vue'
import DataSubjectsSection from '~/components/pages/privacy-policy/DataSubjectsSection.vue'
import ChangesSection from '~/components/pages/privacy-policy/ChangesSection.vue'
import JurisdictionSection from '~/components/pages/privacy-policy/JurisdictionSection.vue'
import DataSharingSection from '~/components/pages/privacy-policy/DataSharingSection.vue'

definePageMeta({
	layout: 'legal',
})

const { t: $t } = useI18n()
const localePath = useLocalePath()

const getDescription = computed(() => {
	return $t(
		`Our Privacy Policy outlines how we collect, use, and protect your personal information. We are committed to safeguarding your data and being transparent about our practices to build and maintain your trust.`,
	)
})
</script>

<template>
	<div class="relative w-full bg-white">
		<div class="bg-[#f5f8fa]">
			<div class="flex flex-col items-center gap-10 sm:gap-24 pb-10 sm:pb-24">
				<!-- Hero Section -->
				<HeroLegalContent
					:title="$t('Your Privacy Matters to Us')"
					:description="getDescription"
					:is-use-slot-desciption="true"
				>
					<template #icon>
						<IconShield class="text-white size-10 sm:size-14" />
					</template>

					<template #description>
						<div class="text-[18px]">
							<p>{{ getDescription }}</p>
							<p class="pt-5">
								{{ $t('You can learn more about the technologies we use in our') }}
								<NuxtLink
									:to="localePath('/cookies')"
									class="underline"
								>
									{{ $t('Cookie Policy') }}
								</NuxtLink>
							</p>
						</div>
					</template>
				</HeroLegalContent>

				<!-- Content Section -->
				<div class="container">
					<div class="bg-white rounded-xl border border-gray-200 p-4 sm:p-14 space-y-10 sm:space-y-14">
						<IntroductionSection />
						<div class="h-px bg-gray-200 mb-14"></div>
						<ControllerSection />
						<div class="h-px bg-gray-200 mb-14"></div>
						<InformationSection />
						<div class="h-px bg-gray-200 mb-14"></div>
						<PersonalDataSection />
						<div class="h-px bg-gray-200 mb-14"></div>
						<DataSharingSection />
						<div class="h-px bg-gray-200 mb-14"></div>
						<DataTransfersSection />
						<div class="h-px bg-gray-200 mb-14"></div>
						<TechnicalSection />
						<div class="h-px bg-gray-200 mb-14"></div>
						<DataSubjectsSection />
						<div class="h-px bg-gray-200 mb-14"></div>
						<ChangesSection />
						<div class="h-px bg-gray-200 mb-14"></div>
						<JurisdictionSection />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
